export default {
  accounts: [],
  banks: [],
  brands: [],
  countries: [],
  offers: [],
  transactions: [],
  session: !!sessionStorage._str
}
